import moment from 'moment';

const states = {
    chatlog_details: {
        message_time_series: [],
        message_filters: { //used as a payload so do not define any key inside this filter
            startDate: moment(new Date(), "DD-MM-YYYY"),
            endDate: moment(new Date(), "DD-MM-YYYY"),
            platform: "all",
            granularity: "hour"
        },
        message_scale: {
            count: { min: 0 },
            timestamp: {
                type: 'time',
                tickInterval: 60 * 60 * 1000 * 4, // 4 hours
                mask: 'DD MMM HH:mm',
                range: [0, 1],
            }
        },
        training_messages: [],
        training_message_filters: { //used as a payload so do not define any key inside this filter
            startDate: moment(new Date(), "DD-MM-YYYY").subtract(1, 'days'),
            endDate: moment(new Date(), "DD-MM-YYYY"),
            searchKey: "",
            isHandled: false,
            isTrained: false,
            limit: 10,
            skip: 0,
        },
        training_message_pagination:{
            more_pages: true,
            current: 1,
        },
        loaders: {
            message_time_series_loading: false,
            message_time_series_load_error: false,
            training_messages_loading: false,
            training_messages_load_error: false,
            message_training: false,
            training_messages_sync_required: false,
        },
    }
};

export default states;



// WEBPACK FOOTER //
// ./src/data/redux/chatlog_details/states.js